export default __webpack_public_path__ + "static/media/cloudfare.80715a98.png";